export default __webpack_public_path__ + "static/media/13.dbbb8c9c.jpg";